import React from "react";
import { Helmet } from "react-helmet";
const HomeHelmet = ({ title }) => {
  return (
    <Helmet>
      <title>
        Global Digital Transformation & IT Solutions Company
      </title>
      <meta
        name="description"
        content="Grow your business today with Digious Solutions. Get expert web design, graphic design, software development, mobile app, & digital marketing services globally."
      />
    </Helmet>
  );
};

export default HomeHelmet;
